import type { FlashTier } from './utils/get-flash-tier';

/** Shared diagonal light-ray art behind every June flash surface (Figma file HxvVtWqzT4xf9mt9xG3VMD). */
export const FLASH_SALE_RAYS_BG = '/images/promotions/flash-sale-rays-bg-v2.jpg';

export const FLASH_SALE_EYEBROW = 'Flash sale';
export const FLASH_SALE_SUBTITLE = 'Learn AI, data and more for less!';
export const FLASH_SALE_CTA_LABEL = 'Save Now';

/**
 * Save Now deep link, by market tier. Uses the full checkout flow (not quick-checkout). The
 * billing frequency differs by market: full-price markets check out on the 4-month bundle,
 * new/low-price markets on the monthly plan (mirrors Memorial Day Sale 2026's full_price_market vs
 * new_price_market split). Use `getFlashSaleCheckoutHref` to append the live coupon.
 */
export const FLASH_SALE_CHECKOUT_HREF: Record<FlashTier, string> = {
  full: '/checkout/individual/4month/credit-card',
  low: '/checkout/individual/monthly/credit-card',
};

/**
 * Tier checkout link with the live coupon appended as `?coupon=<promoCode>`. The coupon also
 * auto-applies from the `COUPON_COOKIE` that `usePromotion` writes; the query param is a fallback in
 * case auto-apply does not run. `promoCode` is the real Braavos coupon from the promotion response
 * (not the gating `promotionId`); when absent, the bare tier link is returned.
 */
export function getFlashSaleCheckoutHref(tier: FlashTier, promoCode?: string | null): string {
  const href = FLASH_SALE_CHECKOUT_HREF[tier];
  if (!promoCode) {
    return href;
  }
  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}coupon=${encodeURIComponent(promoCode)}`;
}

/** Headline copy differs by market tier; everything else is shared (Figma full vs low nodes). */
export const FLASH_SALE_HEADLINE: Record<FlashTier, string> = {
  full: '48% off for 48 hours sitewide',
  low: 'Price drop for 48 hours sitewide',
};
